import { createContext, useContext, useState, useCallback } from 'react';

const CustomerTransitionContext = createContext(null);

export function CustomerTransitionProvider({ children }) {
  // Speichert die Kunden-Daten und Card-Position für die Animation
  const [transitionData, setTransitionData] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('forward'); // 'forward' oder 'backward'

  // Startet die Expand-Animation von der Kundenliste
  const startExpandTransition = useCallback((kunde, cardRect) => {
    setTransitionData({
      kunde,
      cardRect,
      timestamp: Date.now()
    });
    setAnimationDirection('forward');
    setIsAnimating(true);
  }, []);

  // Startet die Collapse-Animation zurück zur Liste
  const startCollapseTransition = useCallback((cardRect) => {
    setTransitionData(prev => prev ? { ...prev, targetRect: cardRect } : null);
    setAnimationDirection('backward');
    setIsAnimating(true);
  }, []);

  // Animation beenden
  const endTransition = useCallback(() => {
    setIsAnimating(false);
    // Transition-Daten nach kurzer Verzögerung löschen (für Zurück-Animation)
    if (animationDirection === 'backward') {
      setTimeout(() => {
        setTransitionData(null);
      }, 100);
    }
  }, [animationDirection]);

  // Transition-Daten löschen
  const clearTransition = useCallback(() => {
    setTransitionData(null);
    setIsAnimating(false);
  }, []);

  return (
    <CustomerTransitionContext.Provider value={{
      transitionData,
      isAnimating,
      animationDirection,
      startExpandTransition,
      startCollapseTransition,
      endTransition,
      clearTransition
    }}>
      {children}
    </CustomerTransitionContext.Provider>
  );
}

export function useCustomerTransition() {
  const context = useContext(CustomerTransitionContext);
  if (!context) {
    throw new Error('useCustomerTransition must be used within CustomerTransitionProvider');
  }
  return context;
}
